import { OneSchemaTemplateOverrides } from '@oneschema/importer'
import { api } from '../index'
import { CustomerImport } from './importHistory'

// --- Types ---

export interface OneSchemaConfig {
  jwt: string
  client_id: string
  template_key: string
  template_overrides: OneSchemaTemplateOverrides
}

interface SubmitCustomerImportParams {
  embed_id: string
  sheet_id: string
  user_list_id: number
  replace_lists?: boolean
  // Original filename from the OneSchema upload payload. Forwarded to
  // the backend so it can derive a human-readable display_filename
  // (DATA-5059). Optional because the OneSchema event shape isn't
  // strictly typed by @oneschema/react.
  original_filename?: string
}

interface SubmitCustomerImportResponse {
  file_upload: {
    id: number
    state: string
    type: string
    file_type: string
    created_at: string
  }
}

interface GetCustomerImportStatusParams {
  fileUploadId: number
}

// --- Endpoints ---

export const customerImportOneSchemaApi = api.injectEndpoints({
  endpoints: builder => ({
    getCustomerImportOneSchemaConfig: builder.query<OneSchemaConfig, void>({
      query: () => ({
        url: 'file_uploads/customer_imports/one_schema_template',
        method: 'GET',
      }),
    }),

    submitCustomerImport: builder.mutation<
      SubmitCustomerImportResponse,
      SubmitCustomerImportParams
    >({
      query: body => ({
        url: 'file_uploads/customer_imports/one_schema_template',
        method: 'POST',
        body,
      }),
      invalidatesTags: (_result, _error, { user_list_id }) => [
        { type: 'UserList', id: `${user_list_id}-imports` },
        { type: 'UserList', id: `${user_list_id}-customers` },
      ],
    }),

    getCustomerImportStatus: builder.query<
      CustomerImport,
      GetCustomerImportStatusParams
    >({
      query: ({ fileUploadId }) => ({
        url: `file_uploads/customer_imports/${fileUploadId}`,
        method: 'GET',
      }),
      transformResponse: (response: { customer_import: CustomerImport }) =>
        response.customer_import,
    }),
  }),
})

export const {
  useGetCustomerImportOneSchemaConfigQuery,
  useSubmitCustomerImportMutation,
  useGetCustomerImportStatusQuery,
} = customerImportOneSchemaApi
